const css = `.exercise-view-icon {
  flex-shrink: 0;
}
.exercise-view-icon .exercise-media-button {
  width: 24px;
  height: 24px;
}
.exercise-view-icon .exercise-media-button .p-button-icon {
  font-size: var(--font-size-sm);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvRXhlcmNpc2VWaWV3SWNvbiIsInNvdXJjZXMiOlsiRXhlcmNpc2VWaWV3SWNvbi5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7O0FBRUE7RUFDRTtFQUNBOztBQUVBO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIuZXhlcmNpc2Utdmlldy1pY29uIHtcbiAgZmxleC1zaHJpbms6IDA7XG5cbiAgLmV4ZXJjaXNlLW1lZGlhLWJ1dHRvbiB7XG4gICAgd2lkdGg6IDI0cHg7XG4gICAgaGVpZ2h0OiAyNHB4O1xuXG4gICAgLnAtYnV0dG9uLWljb24ge1xuICAgICAgZm9udC1zaXplOiB2YXIoLS1mb250LXNpemUtc20pO1xuICAgIH1cbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
